
import React from "react";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import Contact from "../shared/Contact";
import { i18nManager } from "../../i18n";
import Breadcrumb from "../shared/Breadcrumb";
import ContentTitle from "../shared/ContentTitle";
import * as ReactRouterDom from "react-router-dom";
import { Debugger, CacheManager, Utils } from "../../utils";
import { ApiResponseData, IPlatform, ISupportArticle, SanitizedResponse, SupportArticleService, SupportCategoryService, ISupportCategory } from "../../services";

function SupportCategory() {
    const navigate = ReactRouterDom.useNavigate();
    const labels = i18nManager.Labels.support_category;
    const { platform, id } = ReactRouterDom.useParams();
    const activePlatform = CacheManager.getPlatform(platform);
    const supportArticleService = SupportArticleService.getInstance();
    const supportCategoryService = SupportCategoryService.getInstance();
    const [supportCategory, setSupportCategory] = React.useState<ISupportCategory>({} as any);
    const [supportArticles, setSupportArticles] = React.useState<ApiResponseData<ISupportArticle>>({});

    React.useEffect(() => {
        if (!activePlatform) return;
        supportCategoryService.getSingleSupportCategory(id!).then(({ sanitized }: SanitizedResponse<any>) => {
            Debugger.log("SupportCategory:useEffect:getSingleSupportCategory", sanitized);
            setSupportCategory(sanitized);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
            navigate(`/${platform}`);
        });
        supportArticleService.querySupportArticles({ sort: "id,ASC", "platform.external_id": activePlatform?.external_id, size: 100 }).then(({ sanitized }: SanitizedResponse<any>) => {
            Debugger.log("SupportCategory:useEffect:querySupportArticles", sanitized);
            setSupportArticles(sanitized);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
    }, []);

    return (<div className="support">
        <Header title={supportCategory?.name} />
        <Breadcrumb breadCrumbs={[{ label: supportCategory?.name, location: `/${platform}/category/${supportCategory?.external_id}` }]} />
        <ContentTitle title={labels.long_title} />
        <div className="support-category">
            <div className="desc">{supportCategory.description}</div>
            {supportArticles.content?.map((supportArticle) => (<a key={supportArticle.external_id} href={`/${platform}/article/${supportArticle.external_id}`} className="section-title">
                <span>{supportArticle.title}</span>
                <i className="fa fa-arrow-right" />
            </a>))}
        </div>
        <Contact />
        <Footer />
    </div>);
}

export default SupportCategory;
